export default __webpack_public_path__ + "static/media/330_dummy-2014-store01-mobile-de.702c3228.png";